import React, {useState, Fragment, useEffect} from 'react';
import { obtenerRegistrosPersonalizado, obtenerRegistrosPorURL } from 'store/actions/customAction';
import { alertaPersonalizadaSwal } from 'servicios/AlertasPersonalizados';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import { Card, CardContent } from '@mui/material';
import TituloConIcono from 'components/tituloConIcono';
import {useDispatch} from 'react-redux';
import Base64Pdf from 'components/base64pdf';
import { functions } from 'constantes';
import { TablaPersonalizada } from 'components';
import TooltipPersonalizado from 'components/tooltip/TooltipPersonalizado';
import ServiciosDelAPI from 'servicios/ServiciosDelAPI';

const OrdenesDeTransmision = ({ redSocial}) => {
    const dispatch = useDispatch();
    const [datosDeRespuesta, setDatosDeRespuesta] = useState({ tipoDeAlerta: 'error', mensajeDeAlerta: '', mostrarRespuesta: false, });
    const[cargandoSolicitud, setcargandoSolicitud] = useState(false);
    const[datosOrdenesDeTransmision, setDatosOrdenesDeTransmision] = useState([]);
    const[ordenesDeTransmisionPorMedio] = useState("ordenesDeTransmisionPorMedio");
    const [ordenesDeTransmision] = useState('ordenesDeTransmision');
    const [validarDatos, setValidarDatos] = useState({checkearAutorizacion: false, autorizado: true, cargando: true});
    const [responseData, setResponseData] = useState({ errorType: 'error', messageType: '', openResponse: false, }),
    [verPDF, setVerPDF] = useState(false),
    [datosPDF, setDatosPDF] = useState({pdf:'', title:'',});

    const [header] = useState([
      { title: 'Número de Orden', field: 'id'},
      { title: 'Organización política', field: 'oganizacionesPoliticas.nombre', cellStyle:{ maxWidth: '80px' }},
      { title: 'Tipo elecciónn', field: 'tipoDeEleccion.eleccion'},
      { title: 'Cobertura', field: 'nivelDeCobertura.descripcion'},
      { title: 'Instrucciones especiales de transmisión', field: 'instruccionesEspeciales'},
      { title: 'Versiones de orden', field: 'versionDeOrden'},
      { title: 'Fecha de creación', field: 'fechaCreacion', render: (rowData) => functions.FormatearFecha(rowData.fechaCreacion || "")},
      { title: 'Acciones', field: 'accion',
      render: rowData=><div style={{minWidth: '100px'}}>
          {
              (<div>
                  <TooltipPersonalizado title="Ver documento de orden de transmisión" handleFunction={() => verDocumentoDeOrden(rowData)} icon="visibility" fontSize={30} marginTop="0" />
                  <TooltipPersonalizado title="Descagar constancia validada" handleFunction={() => descargarConstanciaValidada(rowData)} icon="cloud_download" fontSize={30} />
              </div>)
          }
          </div>
      },
  ]);

    useEffect( () => {
        obtenerOrdenesDeTransmision()
    }, [])

    const obtenerOrdenesDeTransmision = async () => {
      setcargandoSolicitud(true);

      ServiciosDelAPI[ordenesDeTransmisionPorMedio].metodoDeBusqueda.clear();
      ServiciosDelAPI[ordenesDeTransmisionPorMedio].metodoDeOrden.clear();
      ServiciosDelAPI[ordenesDeTransmisionPorMedio].metodoDeOrden.addDesc("id");

      setcargandoSolicitud(true);
      let respuesta = await dispatch(obtenerRegistrosPersonalizado({
          controller: ordenesDeTransmisionPorMedio,
          saveInStore: false,
          nombreDelMetodo: `listar/ordenesDeTranmision`,
      }));

      setcargandoSolicitud(false);

      if(respuesta?.error) return alertaPersonalizadaSwal( respuesta?.error?.message || 'No se pudieron obtener las ordenes de transmisión');

      if(respuesta?.data?.length === 0) return alertaPersonalizadaSwal('No se encontraron ordenes de transmisión');

      setDatosOrdenesDeTransmision(respuesta?.data);
    }

    const descargarConstanciaValidada = async (rowData) => {
      setcargandoSolicitud(true);

      const {medioDeComunicacion, oganizacionesPoliticas, tipoDeEleccion, id} = rowData;

      let respuesta = await dispatch(obtenerRegistrosPorURL({ controller: ordenesDeTransmision, saveInStore: false, nombreDelMetodo: "obtenerArchivo/validado", parametro: rowData?.id}));

      setcargandoSolicitud(false);

      if(respuesta?.error) return alertaPersonalizadaSwal(respuesta.error?.message || "Inconvenientes al obtener información del documento", "", '');
      if(!respuesta?.data ) return alertaPersonalizadaSwal(respuesta.error?.message || "No encontramos información del documento", "", '');

      functions.descargarBase64EnPDF(respuesta.data, `No. de orden ${id || ""}-${medioDeComunicacion?.nombreConcatenado || ""}-${oganizacionesPoliticas?.nombre || ""}-${tipoDeEleccion?.eleccion || ""}.pdf`)

      return alertaPersonalizadaSwal("La constancia validada se ha descargado de forma automática", "", '');
    }

    const verDocumentoDeOrden = async (rowData) => {
      // setcargandoSolicitud(true);

        // let respuesta = await dispatch(obtenerRegistrosPorURL({ controller: ordenesDeTransmisionPorMedio, saveInStore: false, nombreDelMetodo: "obtenerArchivo", parametro: rowData?.id || ""}));

        // setcargandoSolicitud(false);

        // if(respuesta?.error) return  alertaPersonalizadaSwal(respuesta?.error?.message || "No se puedo obtener el documento, intente nuevamente!",'')

        // if(!respuesta?.data ) return  alertaPersonalizadaSwal(respuesta?.error?.message || "No se puedo obtener el documento, intente nuevamente!",'')

        setDatosPDF({pdf: rowData?.archivo, title: "Documento de orden de transmisión", rowData})

        setVerPDF(true)
    }

    const handClose = (_, reason) => {
        if (reason === 'clickaway') {return}
        changeDataResponse('error', '', false)
    };

    const changeDataResponse = (tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta = false) => setDatosDeRespuesta({tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta,})
    
    const CerrarVerPDF =()=>{ setVerPDF(false)}

    const DescargarPDF = () => {
      const {oganizacionesPoliticas, tipoDeEleccion, nivelDeCobertura, id} = datosPDF.rowData;
      functions.descargarBase64EnPDF(datosPDF?.pdf || "", `Orden No. ${id || ""}-${oganizacionesPoliticas?.nombre || ""}-${nivelDeCobertura?.descripcion || ""}-${tipoDeEleccion?.eleccion || ""}.pdf`);
    }

    const { errorType, messageType, openResponse} = responseData;

    return (
      <Fragment>
      {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : '' }
      <AlertaDeRespuesta type={errorType} content={messageType} open={openResponse} handClose={handClose}/>
      <TituloConIcono title={"Ordenes de transmisión "} icon={""} mostrarBotones={false} mostrarTiempo={false} />
      <Card>
          <CardContent>
            <TablaPersonalizada
                data={datosOrdenesDeTransmision}
                title={"Listado de ordenes de transmisión"}
                header={header}
                refreshList={obtenerOrdenesDeTransmision}
                addRegister={undefined}
                nameToolTipAdd={""}
                pageSize={100}
            />
          </CardContent>
      </Card>
      {verPDF && (
        <Base64Pdf pdf={datosPDF.pdf} title={datosPDF.title} open={verPDF} handleClose={CerrarVerPDF} showDownloadButton={true} src={datosPDF.pdf} DescargarPDF={DescargarPDF} />
      )}
      </Fragment>
    );
}

export default OrdenesDeTransmision;